import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AcademiaResponse } from '../../../types/common';
import { Country, CountryReqBody } from '../../../types/countries';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const useCountryActions = (whichAction: 'countryList' | '') => {
  // query function to fetch all the countries declared here
  const getCountryListHandler = useQuery({
    queryKey: ['country-list'],
    queryFn: async (): Promise<AcademiaResponse<Array<Country>>> => {
      const response = await getPrivateAxiosInstance('user').get(
        '/country/list/'
      );

      return response.data;
    },

    ...returnQueryConfig(whichAction === 'countryList'),
  });

  // mutation function to add new country declared here
  const addNewCountryHandler = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: Array<CountryReqBody>;
    }): Promise<AcademiaResponse<Country>> => {
      const response = await getPrivateAxiosInstance('user').post(
        '/country/create/',
        body
      );

      return response.data;
    },
  });

  // mutation function to update country by id declared here
  const updateCountryByIdHandler = useMutation({
    mutationFn: async ({
      countryId,
      body,
    }: {
      countryId: number;
      body: CountryReqBody;
    }): Promise<AcademiaResponse<Country>> => {
      const response = await getPrivateAxiosInstance('user').patch(
        `/country/${countryId}/partial/update/`,
        body
      );

      return response.data;
    },
  });

  // mutation function to delete country by id declared here
  const deleteCountryByIdHandler = useMutation({
    mutationFn: ({
      countryId,
    }: {
      countryId: number;
    }): Promise<AxiosResponse<AcademiaResponse<null>>> =>
      getPrivateAxiosInstance('user').delete(`/country/${countryId}/delete/`),
  });

  return {
    getCountryListHandler,
    addNewCountryHandler,
    updateCountryByIdHandler,
    deleteCountryByIdHandler,
  };
};

export default useCountryActions;
